module.exports = __webpack_public_path__ + "static/img/log.655c5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/log.png
// module id = EJZI
// module chunks = 58